import { render, staticRenderFns } from "./HomeBtn.vue?vue&type=template&id=3c9b03d8&"
import script from "./HomeBtn.vue?vue&type=script&lang=js&"
export * from "./HomeBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports